<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content class="mat-typography">
<mat-tab-group class="custom-tab-group">
  <mat-tab label="Informações">
    <div class="alerts-container">
      <page-alert message="Alteração realizada com sucesso!" *ngIf="successUpdate && submitted" alertClass="alert-success"></page-alert>
      <page-alert message="Falha ao realizar alteração!" *ngIf="!successUpdate && submitted" alertClass="alert-danger"></page-alert>
    </div>
    <div class="info-container" (click)="changeAvatarDialog()">
      <img [src]="this.defaultPatientPhoto" alt="Avatar" class="user-avatar" />
      <div class="info-details">
        <p><strong>Nome:</strong> {{ this.organizationUser.name }}</p>
        <p><strong>Email:</strong> {{ this.organizationUser.email }}</p>
        <p><strong>Data de criação:</strong> {{ layout.dateFormat(this.organizationUser.createdDate) }}</p>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Permissões">
    <div class="alerts-container">
      <page-alert message="Alteração realizada com sucesso!" *ngIf="successUpdate && submitted" alertClass="alert-success"></page-alert>
      <page-alert message="Falha ao realizar alteração!" *ngIf="!successUpdate && submitted" alertClass="alert-danger"></page-alert>
    </div>

      <mat-card *ngFor="let perm of allPermissions" class="custom-expansion">
        <h4>{{ getPermissionLabel(perm.split(':')[0]) }}</h4>
        <div class="permission-options">
          <mat-checkbox [checked]="userPermissions.includes(perm)" (change)="togglePermission(perm.split(':')[0], $event.checked)">
            Gerenciar o menu '{{ getPermissionLabel(perm.split(':')[0]) }}'
          </mat-checkbox>
        </div>
      </mat-card>

    <div class="permission-actions" align="end">
      <button mat-raised-button color="primary" *ngIf="this.organizationUser.active" (click)="savePermissions()">Salvar Permissões</button>
    </div>
  </mat-tab>
</mat-tab-group>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
  <button mat-flat-button color="warn" *ngIf="this.organizationUser.active" (click)="disableAccess()">Desativar Usuário</button>
  <button mat-flat-button color="accent" *ngIf="!this.organizationUser.active" (click)="activeAccess()">Ativar Usuário</button>

</mat-dialog-actions>
